/* Поведение витрины RESONANCE. Перенесено из nav-mockup.html и переведено с
   выдуманных данных на настоящие: меню и карточки приходят с сервера, корзина
   работает через AJAX-корзину Shopify.

   Один принцип на весь файл: разметку скрипт не сочиняет. Всё, что видно,
   отрисовал Liquid, скрипт только переключает состояния и подменяет куски,
   которые сервер прислал заново. Поэтому суммы и цены нигде не форматируются
   вручную - разойтись с кассой физически нечем. */
(function () {
  'use strict';

  var R = window.RESONANCE || {};
  var body = document.body;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  // счётчик корзины: у значка в шапке - просто число, в остальных местах - в скобках;
  // сам значок сумки виден, только когда в корзине что-то есть (класс rs-has-bag, 29.10.2026)
  function paintBag(n) {
    $$('.bag-count').forEach(function (c) { c.textContent = n ? (c.classList.contains('rs-bag-n') ? n : '(' + n + ')') : ''; });
    document.documentElement.classList.toggle('rs-has-bag', n > 0);
  }

  /* Смахнуть влево или вправо (только телефон, 29.10.2026): шторка корзины
     закрывается, со страницы избранного покупатель возвращается туда, где был.
     Окно едет за пальцем; отпустил раньше порога - встаёт на место. Жест не
     берём у самого края экрана (там системный «назад»), в полях ввода и на том,
     что само листается вбок: фото плитки, ленты. Слушаем документ, а не
     элемент: шторку корзины скрипт перерисовывает целиком. */
  function swipeAway(sel, done) {
    var el = null, x0 = null, y0, t0, dx, dir;
    function sideways(n) {
      for (; n && n !== el; n = n.parentElement) {
        if (n.matches('input,textarea,select,.pimg,.home-rail,[data-noswipe]')) return true;
        if (n.scrollWidth > n.clientWidth + 2 && /auto|scroll/.test(getComputedStyle(n).overflowX)) return true;
      }
      return false;
    }
    function settle(out) {
      var node = el;
      node.style.transition = 'transform .22s cubic-bezier(.19,1,.22,1)';
      node.style.transform = out ? 'translateX(' + (dx > 0 ? 110 : -110) + '%)' : '';
      setTimeout(function () {
        if (out && done(node) === false) return; // страница уходит - на место не возвращаем
        node.style.transition = 'none';
        node.style.transform = '';
        node.offsetWidth; // применить без анимации, потом вернуть свою
        node.style.transition = '';
      }, 220);
    }
    document.addEventListener('touchstart', function (e) {
      x0 = null;
      el = e.target.closest ? e.target.closest(sel) : null;
      if (!el || window.innerWidth > 749 || e.touches.length !== 1) return;
      var t = e.touches[0];
      if (t.clientX < 24 || t.clientX > window.innerWidth - 24 || sideways(e.target)) return;
      x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); dx = 0; dir = '';
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      var t = e.touches[0], dy = t.clientY - y0;
      dx = t.clientX - x0;
      if (!dir) {
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
        dir = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
      }
      if (dir !== 'x') { x0 = null; return; }
      e.preventDefault();
      el.style.transition = 'none';
      el.style.transform = 'translateX(' + dx + 'px)';
    }, { passive: false });
    function end() {
      if (x0 === null) return;
      x0 = null;
      if (dir !== 'x') return;
      var fast = Math.abs(dx) / Math.max(1, Date.now() - t0) > 0.5;
      settle(Math.abs(dx) > Math.min(110, window.innerWidth * 0.28) || (fast && Math.abs(dx) > 40));
    }
    document.addEventListener('touchend', end);
    document.addEventListener('touchcancel', function () { if (x0 !== null && dir === 'x') { x0 = null; settle(false); } else x0 = null; });
  }

  /* ---------- оффер-бар ------------------------------------------------- */
  (function announcements() {
    var wrap = $('#ann');
    if (!wrap) return;
    var msgs = $$('.msg', wrap);
    if (!msgs.length) return;
    msgs[0].classList.add('in');
    if (msgs.length === 1) return;
    var i = 0;
    setInterval(function () {
      var cur = msgs[i];
      i = (i + 1) % msgs.length;
      var next = msgs[i];
      cur.classList.remove('in');
      cur.classList.add('out');
      next.classList.remove('out');
      next.classList.add('in');
      setTimeout(function () { cur.classList.remove('out'); }, 800);
    }, 4200);
  })();


  /* ---------- полоса предпросмотра Shopify ---------------------------------
     В предпросмотре Shopify держит внизу экрана свою полосу и перекрывает ею
     баннер согласия на куки: кнопки видно, а нажать нельзя. Меряем её высоту и
     отдаём в CSS, баннер приподнимается ровно на неё. На витрине полосы нет,
     переменная остаётся нулевой и ничего не двигается.

     Полоса грузится позже страницы, поэтому перепроверяем несколько раз. */
  (function previewBarOffset() {
    function set() {
      var bar = document.getElementById('PBarNextFrameWrapper');
      var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--pbar-h', h + 'px');
    }
    set();
    [400, 1200, 3000].forEach(function (ms) { setTimeout(set, ms); });
    window.addEventListener('resize', set);
  })();

  /* ---------- липкая шапка и строка поиска --------------------------------
     Логика снята с balenciaga.com и работает одинаково на телефоне и на
     десктопе: строка меню закреплена сверху всегда, строка поиска висит под
     ней и уезжает за неё при прокрутке вниз, возвращаясь при прокрутке вверх
     и у самого верха страницы.

     Строка поиска вынута из потока (position:absolute в CSS), поэтому её
     скрытие не меняет высоту документа и страница не дёргается.

     --nav-h нужен панели Filter/Sort: она липнет под строкой меню, а когда
     строка поиска возвращается, та ложится поверх панели - как на эталоне. */
  (function stickyHeader() {
    var shell = $('#shell');
    if (!shell) return;
    var nav = shell.querySelector('header.site');
    var row = shell.querySelector('.searchrow');
    var input = $('#searchInput');

    function measure() {
      var h = nav ? Math.round(nav.getBoundingClientRect().height) : 52;
      document.documentElement.style.setProperty('--nav-h', h + 'px');
      return h;
    }
    var navH = measure();
    window.addEventListener('resize', function () { navH = measure(); });
    if (window.ResizeObserver && nav) new ResizeObserver(function () { navH = measure(); }).observe(nav);

    if (!row) return;

    // пока в поиске работают, прятать строку нельзя
    function busy() {
      return document.activeElement === input || (input && input.value.trim() !== '');
    }
    function show() { shell.classList.remove('compact'); }

    var last = window.scrollY || 0, ticking = false;
    var STEP = 6; // мелкое дрожание прокрутки игнорируем

    function onScroll() {
      var y = window.scrollY || 0;
      if (y <= navH || busy()) { show(); last = y; return; }
      var d = y - last;
      if (Math.abs(d) < STEP) return;
      if (d > 0) shell.classList.add('compact');
      else show();
      last = y;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; onScroll(); });
    }, { passive: true });

    if (input) input.addEventListener('focus', show);

    // лупа в шапке: на телефоне ею и открывают поиск
    var ico = $('#searchBtnM');
    if (ico) ico.addEventListener('click', function () {
      show();
      if (input) setTimeout(function () { input.focus(); }, 60);
    });
  })();

  /* ---------- мега-меню -------------------------------------------------- */
  (function mega() {
    var shell = $('#shell'), megaEl = $('#mega');
    if (!shell || !megaEl) return;
    var panes = $$('.mega-pane', megaEl);
    // «For customers» справа в шапке раскрывается так же, как разделы слева
    var tops = $$('nav.main .top, .hright .top[data-menu]');
    var closeTimer = null;

    function place() {
      // строка поиска вынута из потока, поэтому низ шапки считаем по ней,
      // а когда она уехала за строку меню - по самой строке меню
      var row = shell.querySelector('.searchrow');
      var bottom = shell.getBoundingClientRect().bottom;
      if (row) bottom = Math.max(bottom, row.getBoundingClientRect().bottom);
      megaEl.style.top = bottom + 'px';
      megaEl.style.height = (window.innerHeight - bottom) + 'px';
    }
    function show(name) {
      clearTimeout(closeTimer);
      var found = false;
      panes.forEach(function (p) {
        var match = p.getAttribute('data-pane') === name;
        p.hidden = !match;
        if (match) found = true;
      });
      if (!found) return close();
      tops.forEach(function (t) { t.classList.toggle('active', t.getAttribute('data-menu') === name); });
      place();
      megaEl.classList.add('open');
      // кадры меню грузим все сразу при первом открытии: «ленивая» загрузка откладывала их, и ячейка стояла пустой
      $$('.mega-media img[loading="lazy"]', megaEl).forEach(function (i) { i.loading = 'eager'; });
    }
    function close() {
      megaEl.classList.remove('open');
      tops.forEach(function (t) { t.classList.remove('active'); });
      panes.forEach(function (p) { p.hidden = true; });
    }
    function scheduleClose() { closeTimer = setTimeout(close, 160); }

    tops.forEach(function (t) {
      var name = t.getAttribute('data-menu');
      if (!name) {
        t.addEventListener('mouseenter', scheduleClose);
        return;
      }
      t.addEventListener('mouseenter', function () { show(name); });
      t.addEventListener('mouseleave', scheduleClose);
      // на тач-устройствах первый тап открывает раздел, второй уводит по ссылке
      t.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches && !megaEl.classList.contains('open')) {
          e.preventDefault();
          show(name);
        }
      });
    });
    megaEl.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    megaEl.addEventListener('mouseleave', scheduleClose);
    window.addEventListener('resize', function () { if (megaEl.classList.contains('open')) place(); });
    window.addEventListener('scroll', function () { if (megaEl.classList.contains('open')) place(); }, { passive: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* строка поиска: подсказки в той же панели мега-меню */
    var input = $('#searchInput'), clear = $('#searchClear');
    var searchPane = megaEl.querySelector('[data-pane="search"]');
    if (input && searchPane) {
      var timer = null;
      /* цвет в запросе: словом с сайта или обычным английским (white = Milk), как в выдаче поиска (2026-10-07) */
      var SIN = { 'milk': ['white', 'cream', 'ivory'], 'white': ['milk'], 'nude': ['beige', 'skin', 'ivory'],
        'greige': ['beige', 'grey', 'gray'], 'grey': ['gray'], 'graphite': ['grey', 'gray', 'charcoal'],
        'melange': ['grey', 'gray', 'heather'], 'ash': ['grey', 'gray'], 'mocha': ['brown', 'coffee', 'taupe'],
        'chocolate': ['brown'], 'tofu': ['white', 'cream'], 'ecru': ['white', 'cream', 'beige'], 'pistachio': ['green', 'mint', 'sage'],
        'olive': ['green', 'khaki'], 'fuchsia': ['pink', 'magenta'], 'pink neon': ['pink', 'neon'], 'green neon': ['green', 'neon', 'lime'],
        'dark pink': ['pink'], 'mindal': ['almond', 'beige'], 'light blue': ['blue'], 'blue': ['navy'], 'silver': ['metallic', 'grey', 'gray'],
        'tan': ['beige', 'brown'], 'beige': ['nude'], 'black': ['noir'] };
      var productCache = {};
      function colourInQuery(colour, q) {
        var c = colour.toLowerCase().replace(/-/g, ' ');
        var pq = ' ' + q.toLowerCase().replace(/[-,\/]/g, ' ') + ' ';
        return [c].concat(SIN[c] || []).some(function (w) { return pq.indexOf(' ' + w + ' ') >= 0; });
      }
      function productJson(handle) {
        if (!productCache[handle]) {
          productCache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        }
        return productCache[handle];
      }
      /* как на странице поиска: если есть товары со всеми словами запроса (название, тип, теги, цвета), «похожие» от Shopify не показываем */
      function qWords(q) {
        return q.toLowerCase().replace(/t[\s-]?shirt/g, 'tshirt').replace(/[-,\/+]/g, ' ').split(/\s+/).filter(Boolean).map(function (w) {
          if (w.length > 3 && /(sses|shes|ches|xes)$/.test(w)) return w.slice(0, -2);
          return w.length > 3 && /s$/.test(w) && !/ss$/.test(w) ? w.slice(0, -1) : w;
        });
      }
      function strictHit(p, ws) {
        var hay = (p.title + ' ' + (p.type || '') + ' ' + (p.tags || []).join(' ') + ' ' + (p.options || []).map(function (o) { return (o.values || []).join(' '); }).join(' ')).toLowerCase().replace(/t-shirt/g, 'tshirt').replace(/[-,\/()]/g, ' ');
        return ws.every(function (w) { return (' ' + hay).indexOf(' ' + w) >= 0; });   // по началу слова: ray не находит gray
      }
      function render(q, rows) {
        if (!rows.length) {
          searchPane.innerHTML = '<div class="mega-suggest"><h5>Suggestions</h5><p class="empty">Nothing matches “' + q.replace(/</g, '&lt;') + '”.</p></div>';
          return;
        }
        searchPane.innerHTML = '<div class="mega-suggest"><h5>Suggestions</h5><ul>' +
          rows.slice(0, 8).map(function (r) {
            return '<li><a href="' + r.href + '">' + r.text.replace(/</g, '&lt;') + '</a></li>';
          }).join('') + '</ul></div>';
      }
      function suggest(q) {
        if (!R.routes || !R.routes.predictive) return;
        fetch(R.routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search')
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var items = $$('a[href]', doc).slice(0, 8).map(function (a) {
              return { href: a.getAttribute('href'), text: (a.textContent || '').trim() };
            });
            render(q, items);
            /* товар, у которого в запросе назван цвет, ведём сразу в этот цвет: «Sweatshirt CORD · Milk» */
            Promise.all(items.map(function (it) {
              var m = it.href.match(/^\/products\/([^?\/#]+)/);
              if (!m) return Promise.resolve([it]);
              return productJson(m[1]).then(function (p) {
                if (p) it.strict = strictHit(p, qWords(q));
                if (!p || !p.options) return [it];
                var idx = -1;
                p.options.forEach(function (o, i) { var n = (o.name || o).toString(); if (n === 'Colour' || n === 'Color') idx = i; });
                if (idx < 0) return [it];
                var values = (p.options[idx].values || []);
                var hit = values.filter(function (v) { return colourInQuery(v, q); });
                if (!hit.length) return [it];
                return hit.map(function (v) {
                  var variant = (p.variants || []).filter(function (x) { return x.options && x.options[idx] === v; })[0];
                  return { href: '/products/' + m[1] + (variant ? '?variant=' + variant.id : ''), text: it.text + ' · ' + v, strict: it.strict };
                });
              });
            })).then(function (groups) {
              if (input.value.trim() !== q) return;
              var strict = groups.filter(function (g) { return g[0] && g[0].strict; });
              render(q, [].concat.apply([], strict.length ? strict : groups));
            });
          });
      }
      input.addEventListener('focus', function () { show('search'); });
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clear.classList.toggle('show', q.length > 0);
        show('search');
        clearTimeout(timer);
        if (q.length > 1) timer = setTimeout(function () { suggest(q); }, 220);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && input.value.trim()) {
          window.location.href = R.routes.search + '?q=' + encodeURIComponent(input.value.trim());
        }
      });
      if (clear) clear.addEventListener('click', function () {
        input.value = '';
        clear.classList.remove('show');
        input.focus();
      });
    }
  })();

  /* ---------- мобильное меню --------------------------------------------- */
  (function mobileMenu() {
    var menu = $('#mobile');
    if (!menu) return;
    var burger = $('#burger'), close = $('#mClose');
    function open() { body.classList.add('m-open'); }
    function shut() {
      body.classList.remove('m-open');
      $$('.m-sub', menu).forEach(function (p) { p.classList.remove('open'); });
    }
    if (burger) burger.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    menu.addEventListener('click', function (e) {
      var sub = e.target.closest('[data-sub]');
      if (sub) {
        var pane = menu.querySelector('.m-sub[data-subpane="' + sub.getAttribute('data-sub') + '"]');
        if (pane) pane.classList.add('open');
        return;
      }
      if (e.target.closest('[data-back]')) {
        var p = e.target.closest('.m-sub');
        if (p) p.classList.remove('open');
      }
    });
    var msearch = $('#mSearchInput');
    if (msearch) msearch.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && msearch.value.trim()) {
        window.location.href = R.routes.search + '?q=' + encodeURIComponent(msearch.value.trim());
      }
    });
  })();

  /* ---------- карусель в карточке ---------------------------------------- */
  (function cards() {
    function slides(card) { return $$('.pslide', card); }
    // фото 2-5 плитки грузим, только когда к ней потянулись: наведение, касание, стрелка, точка
    function wake(card) {
      if (!card) return;
      $$('img[data-src]', card).forEach(function (im) {
        im.srcset = im.getAttribute('data-srcset');
        im.src = im.getAttribute('data-src');
        im.removeAttribute('data-src');
      });
    }
    document.addEventListener('mouseover', function (e) { wake(e.target.closest && e.target.closest('.pcard')); });
    document.addEventListener('touchstart', function (e) { wake(e.target.closest && e.target.closest('.pcard')); }, { passive: true });
    function setIdx(card, idx) {
      wake(card);
      var list = slides(card);
      if (!list.length) return;
      idx = (idx + list.length) % list.length;
      card.setAttribute('data-idx', idx);
      var track = $('.ptrack', card);
      if (track) track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      $$('.pdots i', card).forEach(function (d, i) { d.classList.toggle('on', i === idx); });
    }
    document.addEventListener('click', function (e) {
      var arrow = e.target.closest('.parrow');
      if (arrow) {
        e.preventDefault();
        var card = arrow.closest('.pcard');
        setIdx(card, (+card.getAttribute('data-idx') || 0) + (arrow.classList.contains('next') ? 1 : -1));
        return;
      }
      var dot = e.target.closest('.pdots i');
      if (dot) {
        e.preventDefault();
        var c = dot.closest('.pcard');
        setIdx(c, $$('.pdots i', c).indexOf(dot));
      }
    });
    // свайп на телефоне
    var startX = null, startCard = null;
    document.addEventListener('touchstart', function (e) {
      var card = e.target.closest && e.target.closest('.pcard');
      // в ленте на главной свайп листает саму ленту, а не кадры плитки
      if (!card || card.closest('.home-rail')) return;
      startX = e.touches[0].clientX;
      startCard = card;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (startX === null || !startCard) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) setIdx(startCard, (+startCard.getAttribute('data-idx') || 0) + (dx < 0 ? 1 : -1));
      startX = null; startCard = null;
    }, { passive: true });
  })();

  /* ---------- сортировка и фильтры --------------------------------------- */
  (function sortAndFilter() {
    var sortBtn = $('#sortBtn'), sortMenu = $('#sortMenu');
    if (sortBtn && sortMenu) {
      sortBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        sortMenu.hidden = !sortMenu.hidden;
      });
      document.addEventListener('click', function () { sortMenu.hidden = true; });
      sortMenu.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sort]');
        if (!b) return;
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', b.getAttribute('data-sort'));
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var fBtn = $('#filterBtn'), fClose = $('#fClose'), fBack = $('#fBackdrop'), fApply = $('#fApply'), fBody = $('#fBody');
    function openF() { body.classList.add('filter-open'); }
    function closeF() { body.classList.remove('filter-open'); }
    if (fBtn) fBtn.addEventListener('click', openF);
    if (fClose) fClose.addEventListener('click', closeF);
    if (fBack) fBack.addEventListener('click', closeF);
    if (fApply && fBody) fApply.addEventListener('click', function () { fBody.submit(); });
  })();

  /* ---------- корзина ----------------------------------------------------- */
  (function cart() {
    var drawer = $('#cartDrawer');
    var bagBtn = $('#bagBtn');
    function open() { body.classList.add('cart-open'); }
    function close() { body.classList.remove('cart-open'); }

    if (bagBtn) bagBtn.addEventListener('click', open);
    swipeAway('#cartDrawer', close);

    /* Перерисовываем шторку целиком с сервера: так разметка и суммы всегда
       ровно те, что отдал бы Liquid при полной перезагрузке. */
    function refresh() {
      return fetch(R.routes.root + '?section_id=resonance-cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html');
          var next = fresh.querySelector('#cartDrawer');
          var cur = $('#cartDrawer');
          if (next && cur) cur.replaceWith(next);
          var back = fresh.querySelector('#cartBackdrop');
          var curBack = $('#cartBackdrop');
          if (next && back && curBack) curBack.replaceWith(back);
          return fetch(R.routes.cart + '.js').then(function (r) { return r.json(); });
        })
        .then(function (state) {
          paintBag(state.item_count);
        });
    }

    function change(line, quantity) {
      return fetch(R.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line, quantity: quantity })
      }).then(refresh).then(function () {
        /* страница корзины рисуется сервером целиком - обновляем её */
        if (body.classList.contains('template-cart')) window.location.reload();
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('#cartBackdrop') || e.target.closest('#cartContinue')) { close(); return; }
      var item = e.target.closest('.cart-item');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var q = e.target.closest('[data-q]');
      if (q) {
        var span = $('.ci-qty span', item);
        var now = parseInt(span ? span.textContent : '1', 10) || 1;
        change(key, Math.max(0, now + (+q.getAttribute('data-q'))));
        return;
      }
      if (e.target.closest('.ci-remove')) change(key, 0);
    });

    /* Добавление в корзину без перезагрузки страницы */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var data = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('disabled', 'disabled');
      fetch(R.routes.cartAdd + '.js', { method: 'POST', body: data })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (btn) btn.removeAttribute('disabled');
          if (!res.ok) {
            var err = form.querySelector('[data-cart-error]');
            if (err) err.textContent = res.body.description || res.body.message || 'Could not add this item.';
            return;
          }
          return refresh().then(open);
        })
        .catch(function () { if (btn) btn.removeAttribute('disabled'); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); body.classList.remove('filter-open'); }
    });
  })();


  /* ---------- карточка товара -------------------------------------------- */
  (function pdp() {
    var view = $('#pdpView');
    if (!view) return;

    /* На десктопе галерея это стопка кадров - там листать нечего, и попытка
       сдвинуть ленту по горизонтали всё ломает. Слайдер включаем только на
       узком экране, где CSS переводит ту же ленту в строку. */
    var mobile = window.matchMedia('(max-width: 880px)');
    var dots = $$('.pdp-gdots i', view), track = $('.pdp-gtrack', view);
    function setSlide(i) {
      if (!track || !mobile.matches) return;
      var slides = $$('.pdp-slide', view);
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
      track.setAttribute('data-idx', i);
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { setSlide(n); }); });
    var sx = null;
    view.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    view.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) setSlide((+(track && track.getAttribute('data-idx')) || 0) + (dx < 0 ? 1 : -1));
      sx = null;
    }, { passive: true });

    /* подбор варианта: цвет свотчем, размер кнопками */
    var raw = $('#pdpVariants');
    if (!raw) return;
    var variants;
    try { variants = JSON.parse(raw.textContent); } catch (e) { return; }

    var idInput = $('#pdpVariant'), addBtn = $('#pdpAdd'), reqBtn = $('#pdpRequest'), note = $('#pdpNote');
    var chips = $$('.pdp-size', view);

    /* Открытый цвет пишет в форму Liquid (data-colour). Раньше цвет искался по
       aria-pressed у свотчей, а свотчи - это ссылки без этого признака: цвет не
       находился, размер сверялся с любым цветом, и в корзину мог уйти не тот цвет.
       Кнопки размеров сервер рисует уже только для этого цвета. */
    var pdpForm = $('#pdpForm');
    function currentColour() {
      var c = pdpForm && pdpForm.getAttribute('data-colour');
      return c || null;
    }
    function selectedSize() {
      var on = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0];
      return on ? on.getAttribute('data-size') : null;
    }
    function match() {
      var colour = currentColour();
      var size = chips.length ? selectedSize() : null;
      return variants.filter(function (v) {
        var okC = !colour || v.options.indexOf(colour) > -1;
        var okS = !size || v.options.indexOf(size) > -1;
        return okC && okS;
      })[0];
    }
    function needSize() { return chips.length > 0 && !selectedSize(); }
    function sync() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var price = $('[data-price]', view);
      /* Цена приходит уже отформатированной сервером - см. #pdpVariants (со старой ценой и скидкой, если есть). */
      if (price && v.priceHtml) price.innerHTML = v.priceHtml;
      else if (price && v.price) price.textContent = v.price;
      var need = needSize();
      if (addBtn) {
        addBtn.disabled = !need && !v.available;
        addBtn.textContent = need ? 'Add to bag' : (v.available ? 'Add to bag' : 'Sold out');
      }
      if (reqBtn) reqBtn.disabled = !need && !v.available;
      if (note) note.textContent = (!need && !v.available) ? 'This size is sold out in this colour.' : '';
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.disabled) return;
        chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
        sync();
      });
    });
    /* один доступный размер (OS) выбираем сразу - выбирать там нечего */
    var free = chips.filter(function (c) { return !c.disabled; });
    if (chips.length === 1 && free.length === 1) free[0].setAttribute('aria-pressed', 'true');

    /* без размера кнопки не молчат, а просят его выбрать */
    function askSize(e) {
      if (!needSize()) return false;
      if (e) e.preventDefault();
      if (note) note.textContent = 'Please choose a size first.';
      var box = $('#pdpSizes');
      if (box) { box.classList.add('pdp-sizes--ask'); setTimeout(function () { box.classList.remove('pdp-sizes--ask'); }, 1200); }
      return true;
    }
    if (pdpForm) pdpForm.addEventListener('submit', function (e) { if (askSize(e)) e.stopImmediatePropagation(); }, true);
    if (reqBtn) reqBtn.addEventListener('click', function () {
      if (askSize()) return;
      var v = match();
      if (!v || !v.available) return;
      reqBtn.disabled = true;
      fetch(R.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = R.routes.cart + '#requestForm';
      }).catch(function () {
        reqBtn.disabled = false;
        if (note) note.textContent = 'Could not add this item. Please try again.';
      });
    });
    sync();
  })();

  /* ---------- виджет «Написать нам» (как на RU, вариант 2) ------------------ */
  (function chat() {
    var box = $('#rsChat'), btn = $('#rsChatBtn');
    if (!box || !btn) return;
    function set(open) {
      box.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      $$('.rs-chat-item', box).forEach(function (a) { a.tabIndex = open ? 0 : -1; });
    }
    btn.addEventListener('click', function () { set(!box.classList.contains('open')); });
    document.addEventListener('click', function (e) { if (!e.target.closest('#rsChat')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  })();

  /* ---------- таблица размеров шторкой (как на RU) ------------------------
     «Find your size» в карточке открывает шторку справа; без скриптов - страница Size guide. */
  (function sizeGuide() {
    var box = $('#rsSg');
    if (!box) return;
    function open() { body.classList.add('rs-sg-open'); box.setAttribute('aria-hidden', 'false'); var c = $('#rsSgClose'); if (c) c.focus(); }
    function close() { body.classList.remove('rs-sg-open'); box.setAttribute('aria-hidden', 'true'); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sg-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('#rsSgClose') || e.target.closest('#rsSgBack')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  /* ---------- вишлист ------------------------------------------------------
     Хранится в браузере покупателя. Это сознательно: своего аккаунта у нас на
     старте нет, а тащить ради сердечка стороннее приложение дороже пользы. */
  (function wishlist() {
    var KEY = 'resonance:wishlist';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* приватный режим */ }
    }
    function paint() {
      var list = read();
      $$('[data-wish]').forEach(function (b) {
        b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-wish')) > -1 ? 'true' : 'false');
      });
      // счётчик и в шапке, и в мобильном меню
      $$('.wish-count').forEach(function (badge) {
        badge.textContent = list.length ? '(' + list.length + ')' : '';
      });
      $$('.rs-wish-n').forEach(function (n) { n.textContent = list.length || ''; });
      document.documentElement.classList.toggle('rs-has-wish', list.length > 0);
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wish]');
      if (!b) return;
      e.preventDefault();
      var handle = b.getAttribute('data-wish');
      var list = read();
      var at = list.indexOf(handle);
      if (at > -1) list.splice(at, 1); else list.push(handle);
      write(list);
      paint();
      /* на странице избранного убранная вещь сразу исчезает */
      var tile = b.closest('.wish-tile');
      if (tile && at > -1) { tile.remove(); wishState(); }
    });
    paint();

    /* Страница избранного: плитку каждого сохранённого товара нужного цвета
       рисует сервер (секция resonance-wish-tile), скрипт только собирает их. */
    var grid = $('#wishGrid');
    /* смахнул страницу избранного - назад, откуда пришёл; пришёл не с сайта - на главную */
    swipeAway('.wishpage', function () {
      var ref = document.referrer;
      if (ref && ref.indexOf(location.origin) === 0 && history.length > 1) history.back();
      else location.href = R.routes.root || '/';
      return false;
    });
    // вернулся на избранное кнопкой «вперёд» - страница снова на месте
    window.addEventListener('pageshow', function () { var w = $('.wishpage'); if (w) { w.style.transition = ''; w.style.transform = ''; } });
    function wishState() {
      if (!grid) return;
      var has = $$('.wish-tile', grid).length > 0;
      var empty = $('#wishEmpty'), req = $('#wishRequest'), loading = $('#wishLoading');
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = has;
      /* форму прячем при пустом списке, но «спасибо» после отправки оставляем */
      if (req) req.hidden = !has && !$('[data-request-sent]', req);
    }
    if (grid) {
      var keys = read();
      Promise.all(keys.map(function (key) {
        var parts = key.split(':'), handle = parts[0], colour = parts[1] || '';
        return fetch(R.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '?section_id=resonance-wish-tile')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return null;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var tiles = $$('.wish-tile', doc);
            return tiles.filter(function (t) { return t.getAttribute('data-colour') === colour; })[0] || tiles[0] || null;
          })
          .catch(function () { return null; });
      })).then(function (tiles) {
        tiles.forEach(function (t) { if (t) grid.appendChild(document.importNode(t, true)); });
        paint();
        wishState();
      });
    }
  })();

  /* ---------- заявка вместо оплаты -----------------------------------------
     Сайт работает как каталог для друзей (решение 2026-09-30): оплаты нет,
     друг отправляет заявку контактной формой Shopify, письмо приходит на почту
     магазина. Перед отправкой скрипт кладёт в body список вещей: название,
     цвет, размер, количество, цену и ссылку, чтобы заказ собирался без
     переспросов. Цена здесь форматируется по формату магазина только для
     письма - на витрине суммы по-прежнему рисует сервер. */
  (function request() {
    var form = $('#requestForm');
    if (!form) return;
    var source = form.getAttribute('data-source');

    function money(cents) {
      var f = (R.money && R.money.format) || '{{amount}}';
      var n = (cents || 0) / 100;
      function fmt(num, dec, th, dp) {
        var p = num.toFixed(dec).split('.');
        p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
        return p.join(dp);
      }
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_no_decimals') return fmt(n, 0, ',', '.');
        if (k === 'amount_with_comma_separator') return fmt(n, 2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return fmt(n, 0, '.', ',');
        if (k === 'amount_with_apostrophe_separator') return fmt(n, 2, "'", '.');
        return fmt(n, 2, ',', '.');
      }).replace(/<[^>]+>/g, '').replace(/[.,]00(?!\d)/, '');   /* рупии без копеек, как на витрине */
    }
    function abs(url) { return window.location.origin + url; }

    function fromCart() {
      return fetch(R.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) {
        if (!c.items || !c.items.length) return '';
        var lines = c.items.map(function (it, i) {
          return (i + 1) + '. ' + it.product_title + ' - ' + (it.variant_options || []).join(' / ') +
            ' - ' + it.quantity + ' шт - ' + money(it.final_line_price) + '\n   ' + abs(it.url);
        });
        return 'Заявка с сайта (корзина)\n\n' + lines.join('\n') + '\n\nИтого: ' + money(c.total_price);
      });
    }
    function fromWishlist() {
      var tiles = $$('#wishGrid .wish-tile');
      if (!tiles.length) return Promise.resolve('');
      var lines = tiles.map(function (t, i) {
        var sel = $('select', t);
        var size = sel && sel.value ? sel.options[sel.selectedIndex].text : 'размер не выбран';
        var price = $('.wish-price', t);
        return (i + 1) + '. ' + t.getAttribute('data-title') +
          (t.getAttribute('data-colour-name') ? ' - ' + t.getAttribute('data-colour-name') : '') +
          ' - ' + size + (price ? ' - ' + price.textContent.trim() : '') + '\n   ' + abs(t.getAttribute('data-url'));
      });
      return Promise.resolve('Заявка с сайта (избранное)\n\n' + lines.join('\n'));
    }

    /* заявка из корзины ушла - корзину очищаем, чтобы повтор не задвоил вещи */
    if ($('[data-request-sent]', form) && source === 'cart') {
      fetch(R.routes.cart + '/clear.js', { method: 'POST' }).then(function () {
        paintBag(0);
        $$('.cartpage > form, .cartpage .cart-items').forEach(function (el) { el.remove(); });
      });
    }

    form.addEventListener('submit', function (e) {
      var box = $('[data-request-items]', form);
      if (!box || box.value) return;
      e.preventDefault();
      var err = $('[data-request-error]', form);
      (source === 'wishlist' ? fromWishlist() : fromCart()).then(function (text) {
        if (!text) {
          if (err) err.textContent = source === 'wishlist' ? 'Your wishlist is empty.' : 'Your bag is empty.';
          return;
        }
        box.value = text;
        HTMLFormElement.prototype.submit.call(form);
      });
    });
  })();
})();
